import ApiLogin from '@/services/ApiLogin'

const root = 'user'

class UserService {
  about () {
    return ApiLogin().get(`${root}/about`)
  }

  findAll (client) {
    return ApiLogin().get(`${root}/findAll/${client}`)
  }

  insert (item) {
    return ApiLogin().post(`${root}/create`, item)
  }

  update (item) {
    return ApiLogin().put(`${root}/change`, item)
  }

  delete ({ userKey: { clientPrefix, username } }) {
    return ApiLogin().delete(`${root}/delete/${clientPrefix}/${username}`)
  }

  findById (clientPrefix, id) {
    return ApiLogin().get(`${root}/get/${clientPrefix}/${id}`)
  }

  findPermissions () {
    return ApiLogin().get(`${root}/permissions`)
  }

  updatePassword (clientPrefix, username, password) {
    const userKey = { clientPrefix, username }
    return ApiLogin().put(`${root}/update-password`, { userKey, password })
  }

  usernameExists (username) {
    return ApiLogin().get(`${root}/username-exists/${username}`)
  }
}

export default new UserService()
